import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/zones/zone/styles.scss';export default {
  "header": "_header_1jixa_1",
  "icon": "_icon_1jixa_10",
  "name": "_name_1jixa_17",
  "projects": "_projects_1jixa_24"
};